import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import { connect } from 'react-redux';
import { compose, setDisplayName } from 'recompose';
import OutsideClickHandler from 'react-outside-click-handler';

import immutableToJS from 'helpers/immutableToJS';
import { includesSearchText } from 'helpers/utils';
import { DropdownItems } from 'components';
import { FRInput } from 'elements';

export class CustomerToSend extends Component {
  static propTypes = {
    isVendor: PropTypes.bool,
    userContacts: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
      }),
    ).isRequired,
    userBroadCastGroups: PropTypes.arrayOf(PropTypes.string).isRequired,
    value: PropTypes.shape({}),

    formatMessage: PropTypes.func.isRequired,
    onSelect: PropTypes.func,
  };

  static defaultProps = {
    isVendor: false,
    value: {},
    onSelect: noop,
  };

  state = {
    searchText: '',
    showItems: false,
  };

  componentWillReceiveProps({ value }) {
    if (value !== this.props.value) {
      this.setState({
        searchText: value ? `${value.businessName} ${value.email ? `(${value.email})` : ''}` : '',
        showItems: false,
      });
    }
  }

  onBlur = () => {
    this.onBlurTimer = setTimeout(() => this.setState({ showItems: false }), 1000);
  }

  onChangeSearchText = (event) => {
    this.setState({ searchText: event.target.value, showItems: true });
  }

  onClick = (item) => {
    const { onSelect } = this.props;
    onSelect(item);

    this.setState({
      searchText: `${item.businessName} ${item.email ? `(${item.email})` : ''}`,
      showItems: false,
    });
  }

  onFocus = () => {
    if (this.onBlurTimer) {
      clearTimeout(this.onBlurTimer);
    }
    this.setState({ showItems: true });
  }

  getItems = () => {
    const {
      formatMessage,
      isVendor,
      userContacts,
      userBroadCastGroups,
    } = this.props;

    const filteredBroadCastGroups = userBroadCastGroups
      .filter(groupName => groupName.startsWith(isVendor ? 'v-' : 'c-'))
      .map(groupName => groupName.substr('v-'.length));
    const items = filteredBroadCastGroups.map(groupName => ({
      isGroup: true,
      groupName,
      businessName: `${formatMessage('To: ')} Group - ${groupName}`,
      fullName: isVendor
        ? `${formatMessage('Send to All Vendors of Group -')} ${groupName}`
        : `${formatMessage('Send to All Customers of Group -')} ${groupName}`,
    }));
    items.splice(0, 0, {
      isGroup: true,
      groupName: '', // empty string means all
      businessName: formatMessage('To All'),
      fullName: isVendor ? formatMessage('Send to All Vendors') : formatMessage('Send to All Customers'),
    });
    const originalItems = userContacts.filter(u => !u.isDeleted).map(userContact => ({
      contactId: isVendor ? userContact.sellerId : userContact.buyerId,
      businessName: isVendor ? userContact.sellerProfile.companyName :
        userContact.buyerProfile.companyName,
      fullName: isVendor ? `${userContact.sellerProfile.firstName} ${userContact.sellerProfile.lastName}` :
        `${userContact.buyerProfile.firstName} ${userContact.buyerProfile.lastName}`,
      email: isVendor ? userContact.sellerProfile.email : userContact.buyerProfile.email,
    }));
    items.push(...originalItems);
    return items;
  }

  getOptions = () => {
    const { searchText, showItems } = this.state;
    const items = this.getItems();
    if (!items) return [];

    const itemMapped = items.map(item => ({
      id: item.contactId,
      primaryText: item.businessName,
      secondaryText: `${item.fullName} ${item.email ? `(${item.email})` : ''}`,
      onClick: () => this.onClick(item),
    }));

    const options = showItems ? itemMapped.filter(contact => includesSearchText(
      searchText, [contact.primaryText, contact.secondaryText],
    )) : [];

    return options;
  }

  render() {
    const { formatMessage } = this.props;
    const { searchText } = this.state;
    const searchedItems = (
      <DropdownItems
        options={this.getOptions()}
      />
    );

    return (
      <div className="customers-to-send">
        <OutsideClickHandler onOutsideClick={this.onBlur}>
          <FRInput
            fullWidth
            id="to"
            placeholder={formatMessage('To')}
            onChange={this.onChangeSearchText}
            onFocus={this.onFocus}
            value={searchText}
            variant="outlined"
            noAutoComplete
          />
          {searchedItems}
        </OutsideClickHandler>
      </div>
    );
  }
}

/* istanbul ignore next */
const mapStateToProps = (/* state* */) => ({
});

export default compose(
  setDisplayName('CustomerToSend'),
  connect(
    mapStateToProps,
  ),
  immutableToJS,
)(CustomerToSend);
